import { FloatingFormItem, InputText } from '@/components/_common';
import {
  useCouponEquipmentCreate,
  useCouponEquipmentEdit,
} from '@/core/domain/coupon/company/company.hooks';
import {
  CouponEquipment,
  CouponEquipamentFormValues,
} from '@/core/domain/coupon/company/company.types';
import {
  useDefaultEmptyFieldError,
  useDefaultMaxLengthFieldError,
  useRouteMatchParam,
} from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect } from 'react';

interface Props extends ModalProps {
  equipment?: CouponEquipment;
  onCancel: () => void;
}

const CompanyInvoiceCFeCreateModal: React.FC<Props> = ({
  equipment,
  ...props
}) => {
  const companyId = useRouteMatchParam('companyId');
  const [form] = Form.useForm<CouponEquipamentFormValues>();

  const ruleRequired = useDefaultEmptyFieldError();
  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  const couponEquipmentCreate = useCouponEquipmentCreate();
  const couponEquipmentEdit = useCouponEquipmentEdit();

  useEffect(() => {
    if (equipment) {
      form.setFieldsValue(equipment);
    }
  }, [equipment]);

  async function onSumit() {
    try {
      const values = await form.validateFields();

      if (equipment) {
        await couponEquipmentEdit.mutateAsync({
          ...values,
          connectionNumber: values.connectionNumber.toString(),
          id: equipment.id,
          companyId: Number(companyId),
        });
      } else {
        await couponEquipmentCreate.mutateAsync({
          ...values,
          connectionNumber: values.connectionNumber.toString(),
          companyId: Number(companyId),
        });
      }
      handleClose();
    } catch {}
  }

  function handleClose() {
    form.resetFields();
    !!props.onCancel && props.onCancel();
  }

  return (
    <Modal
      {...props}
      title="Cadastro de equipamento SAT"
      onOk={onSumit}
      onCancel={handleClose}
      okText="Salvar"
      confirmLoading={
        couponEquipmentCreate.isLoading || couponEquipmentEdit.isLoading
      }
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem
              label="Versão"
              name="version"
              rules={[ruleRequired, defaultMaxLenghtFieldError(30)]}
              extra="Ex.: 0.07"
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              label="Cód. da caixa"
              name="connectionNumber"
              rules={[ruleRequired, { type: 'number', min: 1, max: 999 }]}
              getValueFromEvent={({ target }) =>
                target.value ? Number(target.value) : undefined
              }
              extra="De 1 a 999"
            >
              <InputText onlyNumber />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              label="Cód. de Série"
              name="serialNumber"
              rules={[ruleRequired, defaultMaxLenghtFieldError(255)]}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              label="Cód. de Ativação"
              name="activationCode"
              rules={[ruleRequired, defaultMaxLenghtFieldError(255)]}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              label="Chave de Assinatura"
              name="signature"
              rules={[ruleRequired]}
            >
              <TextArea />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CompanyInvoiceCFeCreateModal;
